

























































import {Vue, Component} from 'vue-property-decorator';
import RadioElement from '@/components/common/RadioElement.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {addClass, removeClass} from '@/utils/classUtils';
import {popupResize} from '@/utils/ncp';
import { MemberGradesConfigurationsEvaluation, PutMemberGradesConfigurationsEvaluationRequest, EvaluationConditionType } from 'ncp-api-supporter';

interface CurrentConfiguration extends Omit<MemberGradesConfigurationsEvaluation, 'mallNo'> {
  periodType: 'ALL' | 'SELECT'
};

@Component({
  components: {RadioElement, CompSelectBox}
})
export default class MemberGradeEvaluation extends Vue {
  private mallNo = 0;
  private get monthsList() {
    let tempList = [];
    for (let i = 1; i <= 12; i++) {
      tempList.push({value: i, name: i});
    }
    tempList.push({value: 24, name: 24});
    tempList.push({value: 36, name: 36});

    return tempList;
  }

  private changeAutomaticEvaluation() {
    this.evaluationCondition = this.currentConfiguration.evaluationCondition;
    this.evaluationPeriod = this.currentConfiguration.evaluationPeriod || 1;
    this.dayOfAdjustment = this.currentConfiguration.dayOfAdjustment;
    this.validPeriod = this.currentConfiguration.validPeriod;
    this.periodType = this.currentConfiguration.periodType;
  }

  // 가장 마지막으로 저장된 정보
  private currentConfiguration: CurrentConfiguration = {
    evaluationCondition: 'PAY_AMT',
    evaluationPeriod: 1,
    dayOfAdjustment: 1,
    validPeriod: 1,
    periodType: 'ALL',
    used: true
  }; // 디폴트값

  // 자동 등급평가 사용
  private useAutomaticEvaluation = true;
  private useAutomaticEvaluationTypes = {
    name: 'useAutomaticEvaluation',
    data: [
      {
        id: 'use-automatic-evaluation',
        value: true,
        dispaly: 'USABLE_Y'
      },
      {
        id: 'unuse-automatic-evaluation',
        value: false,
        dispaly: 'USABLE_N'
      }
    ]
  }


  // 등급평가조건
  private evaluationCondition: EvaluationConditionType = 'PAY_AMT';
  private oldCondition = 'PAY_AMT';
  private evaluationTypes = {
    name: 'evaluationType',
    data: [
      {
        id: 'evaluationType_PAY_AMT',
        value: 'PAY_AMT',
        dispaly: 'MEMBER_GRADE_EVALUATION_TYPE_PAY_AMT'
      },
      {
        id: 'evaluationType_PAY_CNT',
        value: 'PAY_CNT',
        dispaly: 'MEMBER_GRADE_EVALUATION_TYPE_PAY_CNT'
      },
      {
        id: 'evaluationType_AMT_AND_CNT',
        value: 'AMT_AND_CNT',
        dispaly: 'MEMBER_GRADE_EVALUATION_TYPE_AMT_AND_CNT'
      },
      {
        id: 'evaluationType_AMT_OR_CNT',
        value: 'AMT_OR_CNT',
        dispaly: 'MEMBER_GRADE_EVALUATION_TYPE_AMT_OR_CNT'
      }
    ]
  };

  // 평가기간
  private periodType = 'ALL';
  private periodTypes = {
    name: 'periodTypes',
    data: [
      {
        id: 'periodTypes_ALL',
        value: 'ALL',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'periodTypes_SELECT',
        value: 'SELECT',
        dispaly: 'MEMBER_POPUP_EVALUATION_PERIOD_SELECT'
      }
    ]
  };
  private evaluationPeriod = 1;

  // 등급 유지기간
  private validPeriod = 1;

  // 등급 조정일
  private dayOfAdjustment = 1;
  private daysList = [
    {value: 1, name: 1},
    {value: 5, name: 5},
    {value: 10, name: 10},
    {value: 15, name: 15},
    {value: 20, name: 20}
  ];

  // 저장
  private async save() {
    if (confirm(this.$t('MEMBER_POPUP_EVALUATION_SAVE_CONFIRM') as string)) {
      let request: PutMemberGradesConfigurationsEvaluationRequest = {
        data: {
          evaluationCondition: this.evaluationCondition,
          evaluationPeriod: this.periodType === 'ALL' ? 0 : this.evaluationPeriod,
          dayOfAdjustment: this.dayOfAdjustment,
          mallNo: this.mallNo,
          validPeriod: this.validPeriod,
          used: this.useAutomaticEvaluation
        }
      };
      await this.$api.putMemberGradesConfigurationsEvaluation(request);
      if (this.evaluationCondition !== this.oldCondition) {
        alert(this.$t('MEMBER_POPUP_EVALUATION_OK_MSG1'));
      } else {
        alert(this.$t('MEMBER_POPUP_EVALUATION_OK_MSG2'));
      }
      if (this.$route.query && this.$route.query.callback) {
        $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}();`);
      }
      window.close();
    }
  }

  // 취소
  private cancel() {
    if (confirm(this.$t('MEMBER_POPUP_EVALUATION_CLOSE_CONFIRM') as string)) {
      window.close();
    }
  }

  private async mounted() {
    addClass(document.body, 'popup_small members_wrapper');

    if (this.$route.params && this.$route.params.mallNo) {
      this.mallNo = Number(this.$route.params.mallNo);
      let {data} = await this.$api.getMemberGradesConfigurationsEvaluation({params: {mallNo: this.mallNo}});
      
      // 가장 마지막으로 저장된 정보
      this.currentConfiguration = { ...data, periodType: 'ALL'};
      // 자동 등급평가 사용
      this.useAutomaticEvaluation = data.used;

      // 등급평가조건
      this.evaluationCondition = data.evaluationCondition;
      this.oldCondition = data.evaluationCondition;
      // 평가기간
      if (data.evaluationPeriod !== 0) {
        this.evaluationPeriod = data.evaluationPeriod;
        this.periodType = 'SELECT';
        this.currentConfiguration.periodType = 'SELECT';
      }
      // 등급 유지기간
      this.validPeriod = data.validPeriod;
      // 등급 조정일
      this.dayOfAdjustment = data.dayOfAdjustment;
    }

    this.$nextTick(() => {
      popupResize();
    });
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_small members_wrapper');
  }
}
